(function () {
  function parseData(section) {
    const script = section.querySelector('[data-mglv-product-json]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function money(cents) {
    if (window.mglvCart && window.mglvCart.money) return window.mglvCart.money(cents);
    return new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format((cents || 0) / 100);
  }

  function displayPrice(variant) {
    if (!variant) return '';
    return variant.display_price || money(variant.price);
  }

  function route(path) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function hasStrictVariantAssociation(media, variant, variantCount) {
    if (!media || !Array.isArray(media.variant_ids) || !media.variant_ids.length) return false;
    if (media.variant_ids.length >= variantCount) return false;
    return media.variant_ids.some((variantId) => String(variantId) === String(variant.id));
  }

  function buildGallery(variant, productMedia, variantCount) {
    const seen = new Set();
    const gallery = [];

    function add(media) {
      if (!media || !media.src || seen.has(media.src)) return;
      seen.add(media.src);
      gallery.push(media);
    }

    // Strict variant gallery order:
    // 1) selected variant featured image,
    // 2) selected variant metafield gallery,
    // 3) Shopify admin media linked only to this variant,
    // 4) product admin media only as a final fallback.
    add(variant.featured_media);
    (variant.gallery || []).forEach(add);

    const strictlyAssociated = (productMedia || []).filter((media) => hasStrictVariantAssociation(media, variant, variantCount));
    strictlyAssociated.forEach(add);

    if (!gallery.length) {
      (productMedia || []).forEach(add);
    }

    return gallery;
  }

  function initProduct(section) {
    const data = parseData(section);
    if (!data || !data.variants || !data.variants.length) return;

    const mainImage = section.querySelector('[data-mglv-product-main]');
    const thumbWrap = section.querySelector('[data-mglv-product-thumbs]');
    const price = section.querySelector('[data-mglv-product-price]');
    const stickyPrice = section.querySelector('[data-mglv-sticky-price]');
    const priceMeta = section.querySelector('[data-mglv-price-meta]');
    const stickyTitle = section.querySelector('[data-mglv-sticky-title]');
    const stickyImage = section.querySelector('[data-mglv-sticky-image]');
    const idInputs = section.querySelectorAll('[name="id"]');
    const addButtons = section.querySelectorAll('[data-mglv-product-submit]');
    const requestNotes = section.querySelectorAll('[data-mglv-request-note]');
    const privateAssistanceCtas = section.querySelectorAll('[data-mglv-private-assistance-cta]');
    const form = section.querySelector('[data-mglv-add-form]');
    const stickyBar = section.querySelector('[data-mglv-sticky-buy]');
    const hero = section.querySelector('[data-mglv-product-hero]');

    function select(id) {
      const variant = data.variants.find((item) => String(item.id) === String(id)) || data.variants[0];
      const gallery = buildGallery(variant, data.media || [], data.variants.length);
      const first = gallery[0] || variant.featured_media;

      section.querySelectorAll('[data-mglv-variant]').forEach((button) => {
        const active = String(button.dataset.variantId) === String(variant.id);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      idInputs.forEach((input) => {
        input.value = variant.id;
      });

      if (mainImage && first) {
        mainImage.src = first.src;
        mainImage.alt = first.alt || variant.title || data.title || 'ML1';
      }

      if (thumbWrap) {
        thumbWrap.innerHTML = gallery.map((media, index) => `
          <button type="button" class="mglv-product__thumb${index === 0 ? ' is-active' : ''}" data-mglv-thumb="${index}" aria-label="View image ${index + 1}">
            <img src="${media.src}" alt="" width="76" height="60" loading="lazy">
          </button>
        `).join('');
        thumbWrap.querySelectorAll('[data-mglv-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const media = gallery[Number(thumb.dataset.mglvThumb)];
            if (!media || !mainImage) return;
            mainImage.src = media.src;
            mainImage.alt = media.alt || variant.title || data.title || 'ML1';
            thumbWrap.querySelectorAll('.mglv-product__thumb').forEach((item) => item.classList.remove('is-active'));
            thumb.classList.add('is-active');
          });
        });
      }

      const label = variant.request_only ? (data.request_label || 'Request Availability') : (data.add_label || 'Add to Cart');
      addButtons.forEach((button) => {
        button.textContent = button.dataset.short && variant.request_only ? 'Request' : label;
      });

      requestNotes.forEach((note) => {
        note.hidden = !variant.request_only;
      });

      privateAssistanceCtas.forEach((cta) => {
        cta.hidden = !!variant.request_only;
      });

      if (form) form.dataset.requestOnly = variant.request_only ? 'true' : 'false';
      if (price) price.textContent = variant.request_only ? 'By request' : displayPrice(variant);
      if (priceMeta) {
        priceMeta.hidden = !!variant.request_only;
        if (!variant.request_only && data.price_meta) priceMeta.textContent = data.price_meta;
      }
      if (stickyPrice) stickyPrice.textContent = variant.request_only ? 'By request' : displayPrice(variant);
      if (stickyTitle) stickyTitle.textContent = `ML1 - ${variant.title}`;
      if (stickyImage && first) stickyImage.src = first.src;
    }

    section.querySelectorAll('[data-mglv-variant]').forEach((button) => {
      button.addEventListener('click', () => select(button.dataset.variantId));
    });

    section.querySelectorAll('[data-mglv-variant-jump]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.mglvVariantJump || 0);
        const variant = data.variants[index];
        if (!variant) return;
        select(variant.id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    addButtons.forEach((button) => {
      // MAG-LEV: manage ML1 add-to-cart from click instead of native form submit.
      // Shopify's Google & YouTube pixel can otherwise receive both the form submit
      // signal and the AJAX cart/add.js signal for one click.
      button.setAttribute('type', 'button');

      button.addEventListener('click', (event) => {
        const idInput = form ? form.querySelector('[name="id"]') : section.querySelector('[name="id"]');
        const current = data.variants.find((variant) => String(variant.id) === String(idInput && idInput.value));
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        if (!current) return;

        if (current.request_only) {
          window.location.href = data.request_url || route('pages/contact');
          return;
        }

        if (!form) return;

        if (window.mglvCart && typeof window.mglvCart.add === 'function') {
          window.mglvCart.add(form).catch(() => form.submit());
          return;
        }

        form.submit();
      });
    });

    if (stickyBar && hero) {
      const onScroll = () => {
        stickyBar.classList.toggle('is-visible', window.scrollY > hero.offsetTop + hero.offsetHeight - 120);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    select(data.selected_variant_id || data.variants[0].id);
  }

  function initAll() {
    document.querySelectorAll('[data-mglv-product-section]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
